module.exports = __webpack_public_path__ + "static/media/Blog03.0d56cd30.jpg";